import React, {useEffect, useState} from 'react';
import {makeRequest} from "../../utils/httpRequest";
import {useRecoilState} from "recoil";
import {loadingAtom} from "../../atoms";
import Config from "../../core/config";
import ActionButtonsManagerView from "../common/ActionButtonsManagerView";
import ConfirmButton from "../common/ConfirmButton";import {useNavigate} from "react-router-dom";
import Loading from "../../core/Loading";
import {renderPaymentConditionOptions, UserPermission} from "../../utils/utils";
import {usePermission} from "../../core/PermissionContext";

const apiUrl = Config.apiUrl;

const PaymentTermManager = () => {
    const { hasUserPermission, loadingPermissions } = usePermission();
    const [, setLoading] = useRecoilState(loadingAtom);
    const navigate = useNavigate();
    const searchParams = new URLSearchParams(window.location.search);
    const id = searchParams.get('id');

    const newEntity = {
        id: undefined,
        name: '',
    };

    const [formData, setFormData] = useState(newEntity);

    const handleChange = (e) => {
        const {name, value, type, checked} = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    async function makeQuery() {
        if (id) {
            try {
                setLoading(true);
                const url = apiUrl + '/api/payment_terms/id=' + id;
                const response = await makeRequest(url, 'GET');
                setFormData(response);
            } catch (error) {
                console.error('Error fetching data:', error);
            } finally {
                setLoading(false);
            }
        } else {
            setFormData(newEntity);
        }
    }

    useEffect(() => {
        makeQuery();
    }, [id]);

    function clearEntity() {
        setFormData(newEntity);
    }

    const onConfirm = async () => {

        try {
            if (validateInputs()) {
                setLoading(true);
                await new Promise(resolve => setTimeout(resolve, 300));
                await saveEntity();
                navigate('/app/paymenttermlist');
            }
        } catch (error) {
            console.error('Error saving:', error);
            alert('Error ao salvar.');
        } finally {
            setLoading(false);
        }
    };

    function validateInputs() {

        if (!formData.name || formData.name === '') {
            alert('Preencha o campo nome.');
            return false;
        }

        return true;
    }

    async function saveEntity() {
        const url = apiUrl + '/api/payment_terms';
        setLoading(true);
        try {
            await makeRequest(url, id ? 'PUT' : 'POST', {
                'Content-Type': 'application/json',
            }, JSON.stringify(formData));
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }

    }

    function handlePaymentConditionSelected(value) {
        if (value) {
            setFormData((prevData) => ({
                ...prevData,
                paymentCondition: value
            }));
        }
    }

    if (loadingPermissions) {
        return <Loading/>
    }

    if (hasUserPermission(UserPermission.CREATE_PAYMENT_TERM) === false || (hasUserPermission(UserPermission.EDIT_PAYMENT_TERM) === false && id)) {
        navigate('/unauthorizedaccess');
    }

    return (
        <div style={{width: '300px'}}>
            <div className="header-label">{formData.id > 0 ? 'Editar' : 'Cadastrar'} Condição de Pagamento</div>

            <div style={{marginTop: '5px', alignItems: 'center'}}>
                <div style={{width: '180px'}}>Nome:</div>
                <input type="text" style={{width: '300px'}} value={formData.name} name="name"
                       onChange={handleChange}/>
            </div>

            <div style={{marginTop: '5px', alignItems: 'center'}}>
                <div style={{width: '180px'}}>Condição de Pagamento:</div>
                <select value={formData.paymentCondition}
                        onChange={(e) => handlePaymentConditionSelected(e.target.value)}>
                    <option value="">Selecione a Condição de Pagamento</option>
                    {renderPaymentConditionOptions()}
                </select>
            </div>


            <ActionButtonsManagerView>
                <ConfirmButton onClick={onConfirm}/>
            </ActionButtonsManagerView>


        </div>
    );
};

export default PaymentTermManager;
